var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnarchiveAction = function SvgUnarchiveAction(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.6 9.6h12.8V17a.4.4 0 0 1-.4.4H1a.4.4 0 0 1-.4-.4V9.6Z",
    stroke: "#5E696A",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E696A",
    d: "M5 12h4v1.2H5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 1v6.5M7 1 4 4.2M7 1l3 3.2",
    stroke: "#5E696A",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgUnarchiveAction;